import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteExternalExamOperation = async (
  externalExamId: number,
  setExternalExamId: (externalExamId: number | null) => any,
) => {
  try {
    setExternalExamId(externalExamId);

    const res = await appApi.deleteExternalExam(externalExamId);

    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }

    setExternalExamId(null);
  } catch (e) {
    setExternalExamId(null);
  }
};
